import {NEXT_PUBLIC_IMAGES_URL} from "./publicEnv";

export const s3ImageSource = (id: string, density = 3): string =>
  `${NEXT_PUBLIC_IMAGES_URL}/${id}/${density}x.jpg`;
